import { render, staticRenderFns } from "./PortfolioEditStockDialog.vue?vue&type=template&id=0fe72e04&scoped=true&"
import script from "./PortfolioEditStockDialog.vue?vue&type=script&lang=js&"
export * from "./PortfolioEditStockDialog.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioEditStockDialog.vue?vue&type=style&index=0&id=0fe72e04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe72e04",
  null
  
)

export default component.exports